<template>
  <div>
    <account-statements :creancierID="id" :hiddenFilter="'creancierID = ' + id" nobreadcrumb nofacets nosearch :directLoad="true">

    </account-statements>
  </div>
</template>

<script>
import AccountStatements from "@/views/AccountStatements";
export default {
  name: "creditor-invoices",
  components: {
    AccountStatements
  },
  props: ["id"],
  data() {
    return {
      loaded: false,
    };
  },
  
};
</script>

<style lang="scss" scoped>
</style>